import { useFormikContext } from "formik";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useTramite } from "../context/Tramite";
import { isInvalid } from "../utils/forms";
import "./css/components.css";
import { isEditable } from "../utils/tramite";
import { crearRepresentanteLegal } from "../utils/data";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import ObjectField from "./controls/ObjectField";
import TextField from "./controls/TextField";

export default function RepresentanteLegalForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const [loading, setLoading] = useState(!tramite);
  const handleRepresentanteLegalChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (!tramiteForm.values.representanteLegal) {
      tramiteForm.setFieldValue(
        "representanteLegal",
        crearRepresentanteLegal(),
        false,
      );
    }
  }, [tramiteForm]);
  useEffect(() => {
    setLoading(!tramite);
  }, [tramite]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col>
            <ObjectField
              id="representanteLegal"
              name="representanteLegal"
              value={tramiteForm.values?.representanteLegal}
              onChange={handleRepresentanteLegalChange}
              disabled={!isEditable(tramite)}
            >
              {({ value, setProperty, disabled }) => (
                <Grid>
                  <Row>
                    <Col lg={3}>
                      <TextField
                        id="representanteLegal_documento"
                        name="representanteLegal.documento"
                        label={t("representante.documento")}
                        value={value?.documento}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("documento", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteLegal.documento",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteLegal?.documento,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                    <Col lg={9}>
                      <TextField
                        id="representanteLegal_nombre"
                        name="representanteLegal.nombre"
                        label={t("representante.nombre")}
                        value={value?.nombre}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("nombre", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteLegal.nombre",
                          tramiteForm,
                        )}
                        error={t(tramiteForm.errors.representanteLegal?.nombre)}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <TextField
                        id="representanteLegal_cargo"
                        name="representanteLegal.cargo"
                        label={t("representante.cargo")}
                        value={value?.cargo}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("cargo", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteLegal.cargo",
                          tramiteForm,
                        )}
                        error={t(tramiteForm.errors.representanteLegal?.cargo)}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3}>
                      <TextField
                        id="representanteLegal_telefono"
                        name="representanteLegal.telefono"
                        label={t("representante.telefono")}
                        value={value?.telefono}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("telefono", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteLegal.telefono",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteLegal?.telefono,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                    <Col lg={9}>
                      <TextField
                        id="representanteLegal_correoElectronico"
                        name="representanteLegal.correoElectronico"
                        label={t("representante.correoElectronico")}
                        value={value?.correoElectronico}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("correoElectronico", event.target.value);
                        }}
                        isInvalid={isInvalid(
                          "representanteLegal.correoElectronico",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.representanteLegal
                            ?.correoElectronico,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ObjectField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
